"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";

import { Button, Card, CardContent } from "@louez/ui";
import { CheckCircleIcon } from "@louez/ui/icons";

type QuoteRequestSuccessProps = {
  accountHref: string;
  currency: string;
  onRequestAnother: () => void;
  reservationNumber: string;
  servicesHref: string;
  total: number;
};

export const QuoteRequestSuccess = ({
  accountHref,
  currency,
  onRequestAnother,
  reservationNumber,
  servicesHref,
  total,
}: QuoteRequestSuccessProps) => {
  const t = useTranslations("storefront.services");
  const money = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
  });

  return (
    <Card>
      <CardContent className="flex flex-col items-center py-12 text-center">
        <CheckCircleIcon className="text-primary mb-4 size-12" />
        <h2 className="text-xl font-semibold">{t("quoteSent")}</h2>
        <p className="text-muted-foreground mt-2 max-w-md text-sm">
          {t("quoteSentDescription")}
        </p>
        <dl className="mt-5 grid grid-cols-2 gap-x-5 gap-y-2 text-sm">
          <dt className="text-muted-foreground">{t("quoteNumber")}</dt>
          <dd className="font-medium">{reservationNumber}</dd>
          <dt className="text-muted-foreground">{t("total")}</dt>
          <dd className="font-medium">{money.format(total)}</dd>
        </dl>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Button onClick={onRequestAnother}>{t("requestQuote")}</Button>
          <Button render={<Link href={accountHref} />}>
            {t("viewAccount")}
          </Button>
          <Button variant="outline" render={<Link href={servicesHref} />}>
            {t("backToServices")}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
